import ChooseSeatTicketRoute from './choose-seat.route';
import termaAndConditionsLocale from './terms-and-conditins.locale';

angular.module('BTMS')
.config(termaAndConditionsLocale)
.config(ChooseSeatTicketRoute);



/** WEBPACK FOOTER **
 ** ./client/public/main/choose-seat/index.js
 **/